import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CreditManagement = () => {
  const [currentBalance] = useState(12);
  const [usageHistory] = useState([
    {
      id: 1,
      type: 'unlock',
      description: "Profile unlock - Maria S.",
      amount: -149,
      timestamp: new Date(Date.now() - 3600000),
      candidateId: "ANO-2024-1234"
    },
    {
      id: 2,
      type: 'purchase',
      description: "Credit purchase - 10 unlocks",
      amount: +1490,
      timestamp: new Date(Date.now() - 86400000),
      transactionId: "TXN-2024-5678"
    },
    {
      id: 3,
      type: 'unlock',
      description: "Profile unlock - Erik L.",
      amount: -149,
      timestamp: new Date(Date.now() - 86400000 * 2),
      candidateId: "ANO-2024-5679"
    },
    {
      id: 4,
      type: 'unlock',
      description: "Profile unlock - Anna K.",
      amount: -149,
      timestamp: new Date(Date.now() - 86400000 * 3),
      candidateId: "ANO-2024-5680"
    }
  ]);

  const creditPackages = [
    {
      id: 1,
      unlocks: 5,
      price: 745,
      pricePerUnlock: 149,
      popular: false
    },
    {
      id: 2,
      unlocks: 10,
      price: 1490,
      pricePerUnlock: 149,
      popular: true,
      savings: 0
    },
    {
      id: 3,
      unlocks: 25,
      price: 3350,
      pricePerUnlock: 134,
      popular: false,
      savings: 375
    }
  ];

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    
    if (hours < 24) {
      return `${hours}h ago`;
    } else {
      return `${days}d ago`;
    }
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <h3 className="text-lg font-semibold text-foreground mb-6">Credit Management</h3>
      {/* Current Balance */}
      <div className="bg-primary/5 rounded-lg p-4 mb-6 border border-primary/20">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">Available Credits</p>
            <div className="flex items-baseline space-x-2">
              <span className="text-2xl font-semibold text-primary">{currentBalance}</span>
              <span className="text-sm text-muted-foreground">unlocks</span>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-muted-foreground">Value</p>
            <p className="text-lg font-medium text-foreground">{currentBalance * 149} NOK</p>
          </div>
        </div>
      </div>
      {/* Purchase Options */}
      <div className="mb-6">
        <h4 className="font-medium text-foreground mb-4">Purchase More Credits</h4>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {creditPackages?.map((pkg) => (
            <div key={pkg?.id} className={`relative p-4 rounded-lg border-2 transition-all ${
              pkg?.popular 
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
            }`}>
              {pkg?.popular && (
                <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
                  <span className="px-3 py-1 text-xs font-medium bg-primary text-primary-foreground rounded-full">
                    Popular
                  </span>
                </div>
              )}
              
              <div className="text-center">
                <div className="text-lg font-semibold text-foreground">{pkg?.unlocks} Unlocks</div>
                <div className="text-2xl font-bold text-primary mt-1">{pkg?.price} NOK</div>
                <div className="text-xs text-muted-foreground mt-1">
                  {pkg?.pricePerUnlock} NOK per unlock
                </div>
                {pkg?.savings > 0 && (
                  <div className="text-xs text-success font-medium mt-1">
                    Save {pkg?.savings} NOK
                  </div>
                )}
                
                <Button 
                  variant={pkg?.popular ? "default" : "outline"} 
                  size="sm" 
                  fullWidth 
                  className="mt-3"
                >
                  Purchase
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Usage History */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h4 className="font-medium text-foreground">Recent Transactions</h4>
          <button className="text-sm text-primary hover:text-primary/80 transition-micro">
            View all
          </button>
        </div>
        
        <div className="space-y-3">
          {usageHistory?.slice(0, 4)?.map((transaction) => (
            <div key={transaction?.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div className="flex items-center space-x-3">
                <div className={`h-8 w-8 rounded-full flex items-center justify-center ${
                  transaction?.type === 'unlock' ?'bg-destructive/10 text-destructive' :'bg-success/10 text-success'
                }`}>
                  <Icon 
                    name={transaction?.type === 'unlock' ? 'Unlock' : 'Plus'} 
                    size={16} 
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">
                    {transaction?.description}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {formatTimeAgo(transaction?.timestamp)}
                  </p>
                </div>
              </div>
              
              <div className="text-right">
                <span className={`text-sm font-medium ${
                  transaction?.amount > 0 ? 'text-success' : 'text-destructive'
                }`}>
                  {transaction?.amount > 0 ? '+' : ''}{transaction?.amount} NOK
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreditManagement;